export { default } from './SpotThumbnailBackground';
